export default __webpack_public_path__ + "static/media/Snd1.899eacbd.mp3";